module.exports = __webpack_public_path__ + "static/media/n.35c88755.jpg";